import { NormalizeOAS, OASResponse } from 'fets';
import type openapi from '../openapi';
import { ApiClient } from '../fetsClient';
import { assertNever } from '../utils';

type Params = {
  progressTrackingId: number;
};

type Result = {
  data: string | null;
};

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<Result>;

export const createGetTrackingData = (apiClient: ApiClient): ApiFunction => {
  const getTrackingData = async (params: Params, signal?: AbortSignal): Promise<Result> => {
    const response = await apiClient['/api/progress-tracking/{progressTrackingId}'].get({
      params: { progressTrackingId: params.progressTrackingId },
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return getTrackingData;
};

type Response = OASResponse<NormalizeOAS<typeof openapi>, '/api/progress-tracking/{progressTrackingId}', 'get'>;

const convertResponse = async (response: Response): Promise<Result> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }

  const body = await response.json();
  return { data: body.data };
};
